exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit {\n  color: white; }\n\n.disabled {\n  pointer-events: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/units/unit-detail/unit-detail.component.scss
// module id = ../../../../../src/app/theme/pages/aside-left-display-disabled/units/unit-detail/unit-detail.component.scss
// module chunks = main